import { render, staticRenderFns } from "./RenameArchiveModal.vue?vue&type=template&id=6f86846f&scoped=true&lang=pug"
import script from "./RenameArchiveModal.vue?vue&type=script&lang=js"
export * from "./RenameArchiveModal.vue?vue&type=script&lang=js"
import style0 from "./RenameArchiveModal.vue?vue&type=style&index=0&id=6f86846f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86846f",
  null
  
)

export default component.exports